export const BASE_API_URL = "//goldbe.services-money91.com/";
// export const BASE_API_URL = 'http://13.233.236.54:5002/';
export const FILE_UPLOAD_URL = "https://media.getzyk.com/uploadMediaFile/6";
export const GOLD_QA = [
  {
    title: "सेफगोल्ड क्या है?",
    message:
      "सेफगोल्ड सभी लागू कानूनों और विनियमों के अनुपालन में 24 कैरेट सोना खरीदने का एक संगठित और पारदर्शी तरीका है। सेफगोल्ड न तो एक वित्तीय उत्पाद है और न ही जमा लेकिन आपकी व्यक्तिगत जरूरतों के लिए सोना खरीदने का एक तरीका है। आप अपनी इच्छा के अनुसार इस योजना के तहत सोना खरीद सकते हैं और आपको कभी भी और जितनी बार चाहें उतनी बार सोने की भौतिक डिलीवरी लेने की पूरी स्वतंत्रता है। चूँकि सोने की भिन्नात्मक मात्रा को वितरित करना शारीरिक रूप से संभव नहीं है, इसके लिए न्यूनतम मात्रा को प्रस्तावित किया जाना आवश्यक है जिसे 1 ग्राम से कम और 1 ग्राम के गुणकों में रखा गया है। लेन-देन के लिए आपके द्वारा उपलब्ध कराए जा रहे स्पष्ट निधियों के आधार पर आपकी ओर से सोना खरीदा जाएगा। 4 दशमलव स्थानों पर ग्राम में सोना आपके खाते में जमा किया जाएगा।"
  },
  {
    title: "डिजिटल गोल्ड इंडिया प्राइवेट लिमिटेड कौन है?",
    message:
      "डिजिटल गोल्ड इंडिया प्राइवेट लिमिटेड संस्थागत स्वामित्व में विश्व स्वर्ण परिषद के साथ अल्पसंख्यक निवेशक (वर्ल्ड गोल्ड काउंसिल (इंडिया) प्राइवेट लिमिटेड के माध्यम से) के स्वामित्व में है। सेफगोल्ड डिजिटल गोल्ड इंडिया प्राइवेट लिमिटेड का एक उत्पाद है। "
  },
  {
    title: "सेफगॉल्ड द्वारा पेश की जाने वाली सोने की शुद्धता क्या है?",
    message:
      "सेफगॉल्ड 245 कैरेट गोल्ड की 995 सुंदरता (99.5% शुद्ध) प्रदान करता है।"
  },
  {
    title: "सुरक्षा ट्रस्टी की भूमिका क्या है?",
    message:
      "सेफगोल्ड ने हमारे सभी ग्राहकों के लिए सुरक्षा ट्रस्टी के रूप में कार्य करने के लिए आईडीबीआई ट्रस्टीशिप सर्विसेज लिमिटेड के साथ एक संबंध बनाया है। सुरक्षा ट्रस्टी आपकी ओर से कार्य करने का अधिकारी है और यह सुनिश्चित करता है कि आपके हितों की रक्षा हो। सिक्योरिटी ट्रस्टी के पास आपके द्वारा रखे गए सोने से जुड़ा हुआ चार्ज होगा।"
  },
  {
    title:
      "सुरक्षित खाते में परिसमापन में जाने की संभावना नहीं होने पर, मेरे खाते में जमा होने से जुड़े सोने का क्या होगा?",
    message:
      "आपके खाते में जमा राशि से जुड़ा सोना सेफगोल्ड की अन्य परिसंपत्तियों से अलग है। आईडीबीआई ट्रस्टीशिप सर्विसेज लिमिटेड, एक स्वतंत्र ट्रस्टी, आपकी ओर से काम करता है। आपके खातों में संचय से जुड़ी कंपनी द्वारा खरीदा गया सोना कस्टोडियन के पास रखा जाता है। जब आप डिलीवरी के लिए पूछते हैं, तो कस्टोडियन से सोने की अपेक्षित मात्रा को हटा दिया जाएगा और एक प्रतिष्ठित कूरियर सेवा के माध्यम से आप तक पहुंचाया जाएगा। चूंकि सिक्योरिटी ट्रस्टी के पास सोने पर शुल्क है, इसलिए कंपनी को होने वाली कोई भी प्रतिकूल घटना आपके खाते में जमा होने से जुड़े सोने को प्रभावित नहीं करेगी। इसके अलावा, सोने का शीर्षक आपके साथ स्पष्ट रूप से रहता है और सेफगोल्ड ग्राहकों के खाते में कस्टोडियन के साथ संग्रहित भौतिक सोना किसी भी तरह से सेफगोल्ड की संपत्ति नहीं है।"
  },
  {
    title: "सेफगोल्ड के तहत उपलब्ध विभिन्न कार्यकाल क्या हैं?",
    message: "आप किसी भी निश्चित या आवधिक भुगतान करने के लिए बाध्य नहीं हैं।"
  },
  {
    title: "शारीरिक तिजोरी का बीमा कौन करेगा?",
    message:
      "सुरक्षित भंडारण प्रदाता (ब्रिंक) की एक व्यापक, वैश्विक बीमा पॉलिसी है जिसमें आपके सोने को उनके वाल्ट में संग्रहीत बीमा कवर शामिल है। इसके अलावा, SafeGold में पारगमन में सोने को कवर करने के लिए एक अतिरिक्त बीमा पॉलिसी है।"
  },
  {
    title: "सेफगोल्ड खरीदने के लिए पात्रता / मानदंड क्या है?",
    message: "कोई भी भारतीय निवासी सेफगोल्ड के लिए नामांकन कर सकता है। "
  },
  {
    title: "इस योजना के लिए न्यूनतम और अधिकतम राशि क्या है?",
    message: "खरीद की न्यूनतम राशि Rs 1 है "
  },
  {
    title: "मैं अपना सोना कैसे बेचूं?",
    message:
      "डिजिटल गोल्ड इंडिया प्राइवेट लिमिटेड (कंपनी) प्लेटफ़ॉर्म ऐप पर एक विक्रय मूल्य उद्धरण प्रदान करता है। आप न्यूनतम रे से शुरू होने वाली किसी भी राशि को बेचना चुन सकते हैं। सोने की एक अधिकतम राशि जो आपके पास है। सराफा बाजार में विघटन की संभावना नहीं होने पर बिक्री भाव अस्थायी रूप से अनुपलब्ध हो सकता है।"
  },
  {
    title: "किस कीमत पर सोना ग्राहकों से बेचा / खरीदा जाता है?",
    message:
      "सेफगॉल्ड आपके लिए एक लाइव खरीद-बिक्री उद्धरण प्रकाशित करेगा जो कि परिचालन लागत को कवर करने के लिए थोक सराफा बाजार और एक कमीशन से प्राप्त किया जाएगा। आपके द्वारा भुगतान किया गया वास्तविक खरीद मूल्य हमेशा पारदर्शी रूप से प्रकाशित किया जाएगा ताकि आपके पास लेनदेन में प्रवेश करने से पहले अन्य सभी स्रोतों से तुलना करने का मौका हो।"
  },
  {
    title: "मुझे प्रत्येक आदेश के लिए चालान कहां मिल सकता है?",
    message:
      "यदि आपका ईमेल पता प्रदान किया गया है, तो एक चालान आपको प्रत्येक सफल लेनदेन के बाद एक अनुलग्नक के रूप में ईमेल किया जाएगा। यह चालान बटन पर क्लिक करके, प्लेटफ़ॉर्म पर भी उपलब्ध है।"
  },
  {
    title: "मैं अपना होल्डिंग स्टेटमेंट कैसे प्राप्त कर सकता हूं?",
    message: "मंच पर हर समय एक ऑनलाइन विवरण उपलब्ध होगा।"
  },
  {
    title: "क्या मेरे संचय से जुड़ा सोना सुरक्षित अभिरक्षा में रखा गया है?",
    message:
      "आपकी ओर से खरीदा गया सोना ब्रिंक के साथ दुनिया भर में कीमती धातुओं के प्रमुख सुरक्षित रक्षक के रूप में संग्रहीत किया जाता है। सोने का बीमा, भंडारण और पारगमन दोनों के लिए किया जाता है, जब आपको पहुंचाया जाता है। इसके अलावा, IDBI ट्रस्टीशिप के पास आपके पक्ष में तिजोरी में संग्रहीत सभी सोने पर शुल्क है। यह सुनिश्चित करता है कि किसी भी बाहरी घटनाओं की परवाह किए बिना आपका सोना हर समय संरक्षित है।"
  },
  {
    title:
      "उस समय की अधिकतम अवधि क्या है जिसके लिए मेरा सोना सेफगोल्ड के साथ संग्रहित किया जा सकता है?",
    message:
      "आप खरीद की तारीख से 7 साल की अवधि के लिए अपने सोने को सेफगोल्ड के साथ स्टोर कर सकते हैं। हिरासत पहले 24 महीनों के लिए शुल्क के बिना होगी, और उसके बाद, भंडारण लागत को कवर करने के लिए नाममात्र शुल्क के लिए सेफगॉल्ड द्वारा संग्रहीत किया जाना जारी रहेगा। शुल्क वसूल किए जाने से पहले आपको सूचित कर दिया जाएगा, और आपके पास हर समय अपने सोने की डिलीवरी बेचने या अनुरोध करने का विकल्प होगा।"
  },
  {
    title: "क्या मेरे संचय से जुड़ा सोना सुरक्षित अभिरक्षा में रखा गया है?",
    message:
      "आपकी ओर से खरीदा गया सोना ब्रिंक के साथ दुनिया भर में कीमती धातुओं के प्रमुख सुरक्षित रक्षक के रूप में संग्रहीत किया जाता है। सोने का बीमा, भंडारण और पारगमन दोनों के लिए किया जाता है, जब आपको पहुंचाया जाता है। इसके अलावा, IDBI ट्रस्टीशिप के पास आपके पक्ष में तिजोरी में संग्रहीत सभी सोने पर शुल्क है। यह सुनिश्चित करता है कि किसी भी बाहरी घटनाओं की परवाह किए बिना आपका सोना हर समय संरक्षित है।"
  },
  {
    title: "क्या इस योजना के लिए कोई लॉक-इन अवधि है?",
    message:
      "नहीं, खरीद की तारीख से कोई लॉक-इन अवधि नहीं है। आप न्यूनतम बिक्री के लिए फिर से न्यूनतम मूल्य के साथ शुरू होने वाले किसी भी सोने को बेचना पसंद कर सकते हैं। 1 / - सोने की अधिकतम राशि जो आपके पास है।"
  },
  {
    title: "क्या इस योजना के लिए मेरा संयुक्त खाता हो सकता है?",
    message: "नहीं, आपके पास SafeGold के लिए एक संयुक्त खाता नहीं हो सकता है।"
  },
  {
    title: "क्या मैं अपना सोना बेचने के आदेश / अनुरोध को रद्द करता हूं?",
    message:
      "नहीं, आप उस आदेश को रद्द नहीं कर सकते, जिसे एक बार प्लेटफ़ॉर्म पर सफलतापूर्वक रखा गया हो."
  },
  {
    title: "यदि मैं योजना के कार्यकाल के दौरान मर जाऊं तो क्या होगा?",
    message:
      "आपकी मृत्यु की स्थिति में, यदि विशेष रूप से सेफगॉल्ड द्वारा आवश्यक देय परिश्रम के अधीन अनुमति दी जाती है, तो आपके गोल्ड की तिजोरी में शीर्षक और आपका खाता आपके कानूनी उत्तराधिकारी को हस्तांतरित हो जाएगा।"
  },
  {
    title:
      "यदि मेरा खाता प्लेटफ़ॉर्म पर चालू नहीं हुआ तो मेरे सोने का क्या होगा?",
    message:
      "हम हमेशा आपके सोने तक तत्काल पहुंच प्रदान करने का प्रयास करेंगे। यदि, फिर भी, आपके खाते को किसी भी कारण से निलंबित कर दिया गया है, तो हम आपसे अनुरोध करेंगे कि आप अपने खाते को फिर से सक्रिय करने के लिए प्लेटफ़ॉर्म के ग्राहक सेवा केंद्र से संपर्क करें और अपने सोने को एक बार फिर से एक्सेस करें। ग्राहक हमारे ग्राहक सेवा केंद्र के साथ एक माध्यमिक सहारा के रूप में संपर्क कर सकते हैं। "
  }
];
